import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

import {
  white,
  black,
  brand,
  brandDarker,
  error,
  redLight,
  brandLight,
  grey70,
  grey10,
  grey5,
} from 'variables/colors';
import {
  borderRadius,
  borderRadiusSmall,
  boxShadowBrand,
  transition,
} from 'variables/general';
import { fontWeightBold, montserrat } from 'variables/font';

const primaryContainedHover = brandDarker;

const getColor = ({ variant, color }) => {
  if (variant === 'contained') {
    return white;
  }

  if (variant === 'outlined') {
    if (color === 'primary') {
      return brand;
    }

    if (color === 'error') {
      return error;
    }

    return grey70;
  }

  return white;
};

const getPadding = ({ size, variant }) => {
  if (variant === 'outlined') return '14px 1.5em';
  if (size === 'small') {
    return '0 .7em';
  }

  return '0 1.5em';
};

const getBorderColor = ({ variant, color }) => {
  if (variant === 'outlined') {
    if (color === 'primary') {
      return `2px solid ${brand}`;
    }

    if (color === 'error') {
      return `2px solid ${error}`;
    }

    return `2px solid ${grey10}`;
  }

  return '0em solid';
};

const getHoverBackground = ({ variant, color }) => {
  if (variant === 'contained') {
    if (color === 'primary') {
      return primaryContainedHover;
    }
  }

  if (variant === 'outlined') {
    if (color === 'primary') {
      return brandLight;
    }

    if (color === 'error') {
      return redLight;
    }

    return grey5;
  }
};

export const BrandButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 3.125em;
  padding: ${(p) => getPadding(p)};
  font-size: 1em;
  background: ${({ variant }) => (variant === 'contained' ? brand : white)};
  border: ${(props) => getBorderColor(props)};
  border-radius: ${({ size }) =>
    size === 'small' ? borderRadiusSmall : borderRadius};
  box-shadow: ${({ boxShadow }) => boxShadow && boxShadowBrand};
  cursor: ${({ disabled }) => !disabled && 'pointer'};
  opacity: ${({ disabled }) => (disabled ? '.4' : '1')};

  &:hover {
    background: ${(props) => !props.disabled && getHoverBackground(props)};
    transition: ${({ disabled }) => !disabled && transition};
  }

  .MuiSvgIcon-root {
    margin-right: 0.3em;
    color: ${white};
  }
`;
export const ButtonText = styled.span`
  color: ${(p) => getColor(p)};
  font-weight: ${fontWeightBold};
  font-size: ${({ size }) => (size === 'large' ? '1em' : '.875em')};
  font-family: ${montserrat};
`;

export const StyledLink = styled(Link)`
  &:visited,
  &:hover,
  &:active {
    color: ${(p) => (p.outlined ? brand : white)};
  }
`;
